import React from 'react';
import { defaultMemoize } from 'reselect';
import _indexOf from 'lodash/indexOf';
import _map from 'lodash/map';
import _compact from 'lodash/compact';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import styles from './note.module.scss';
var REGEX_GET_ENTITES_TAGS = /(=?@{USER-.*?})/g;
var REGEX_GET_ENTITES = /@{USER-.*?}/gim;
var getIdFromMention = function getIdFromMention() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_STRING;
  return value.slice(_indexOf(value, '-') + 1, -1);
};
export var translateUserMentioned = defaultMemoize(function () {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_STRING;
  var users = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var values = text.split(REGEX_GET_ENTITES_TAGS);
  var textWithUsers = _map(values, function (val) {
    if (REGEX_GET_ENTITES.test(val)) {
      var id = getIdFromMention(val);
      return users[id] ? "@".concat(users[id].displayName) : EMPTY_STRING;
    }
    return val;
  }) || [];
  return textWithUsers.join(EMPTY_STRING);
});
export var translateUserMentionedToJSX = defaultMemoize(function () {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_STRING;
  var users = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var values = text.split(REGEX_GET_ENTITES_TAGS);
  return _map(values, function (val) {
    if (REGEX_GET_ENTITES.test(val)) {
      var id = getIdFromMention(val);
      return users[id] ? /*#__PURE__*/React.createElement("span", {
        className: styles.notesTag
      }, "@", users[id].displayName) : EMPTY_STRING;
    }
    return val;
  });
});
export var getTaggedUsersFromText = function getTaggedUsersFromText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_STRING;
  var values = text.split(REGEX_GET_ENTITES_TAGS);
  return _compact(_map(values, function (val) {
    if (REGEX_GET_ENTITES.test(val)) {
      var id = getIdFromMention(val);
      return id;
    }
    return null;
  }));
};
export var convertDisplayNamesToUserIds = function convertDisplayNamesToUserIds(text, users) {
  var value = text;
  _map(users, function (_ref, key) {
    var displayName = _ref.displayName;
    value = value.replaceAll("@".concat(displayName), "@{USER-".concat(key, "}"));
  });
  return value;
};